import { Action } from 'redux';

import { EditConnections } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export interface EditConnectionAction extends Action {
  dataConnectionsOrSources: IContentInfo[];
}

export function editDataConnections(dataConnectionsOrSources: IContentInfo[]): EditConnectionAction {
  return {
    type: EditConnections,
    dataConnectionsOrSources
  };
}

export const isEditDataConnectionAction = isActionFactory<EditConnectionAction>(EditConnections);
